import React, { FC } from "react";

import { useDataLayer } from "../../../hooks/use-data-layer";
import { useRenderDateRange } from "../../../hooks/use-render-date-range";
import { GoogleAnalyticsEvent } from "../../../utils/analytics";
import { ContactCard } from "../../cards/contact-card";
import { ContactCardColor } from "../../cards/contact-card/types";
import { Icon } from "../../icon";
import { RichText } from "../../rich-text";

export interface ExhibitionStripCardProps
  extends Pick<
    Queries.ExhibitionStripDataFragment,
    | "startDate"
    | "endDate"
    | "location"
    | "ticketPurchaseLink"
    | "node_locale"
    | "address"
    | "timeStart"
    | "timeEnd"
    | "defaultLocaleEntry"
  > {}

export const ExhibitionStripCard: FC<ExhibitionStripCardProps> = ({
  startDate: startDateAsString,
  endDate: endDateAsString,
  location,
  ticketPurchaseLink,
  address,
  timeStart,
  timeEnd,
  defaultLocaleEntry,
}) => {
  const [dateLine1, dateLine2, dateLine3] = useRenderDateRange({
    startDateAsString,
    endDateAsString,
    renderMonth: "long",
  });
  const { pushEvent } = useDataLayer();
  const ctas = [ticketPurchaseLink];
  return (
    <ContactCard
      color={ContactCardColor.PRIMARY}
      ctas={ctas}
      logo={null}
      body={null}
      onClickCta={(i) => {
        if (i === ctas.indexOf(ticketPurchaseLink) && defaultLocaleEntry) {
          pushEvent({
            event: GoogleAnalyticsEvent.BuyExhibitionTicketCta,
            exhibition_name: defaultLocaleEntry.title,
          });
        }
      }}
      className="w-full md:w-auto lg:w-96 flex-none"
    >
      <div className="text-light flex flex-col gap-4">
        {dateLine1 && dateLine2 && (
          <div className="font-medium text-2xl leading-tight">
            {[dateLine1, dateLine2, dateLine3].join(" ")}
          </div>
        )}
        {(address?.raw || location) && (
          <div className="font-light text-base leading-snug flex flex-row gap-0.5">
            <Icon icon="map-pin" size={25} className="p-1" />
            <div>
              <RichText raw={address?.raw} />
              {location}
            </div>
          </div>
        )}
        {location && (
          <div className="font-light text-base leading-snug flex flex-row gap-0.5">
            <Icon icon="clock" size={25} className="p-1" />
            {[timeStart, timeEnd].join(" - ")}
          </div>
        )}
      </div>
    </ContactCard>
  );
};
